import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2eb594a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "list-item"
}
const _hoisted_2 = {
  key: 1,
  class: "list-item"
}
const _hoisted_3 = { class: "text-empty-state" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_content_loader = _resolveComponent("base-content-loader")!
  const _component_previous_visit = _resolveComponent("previous-visit")!

  return (_openBlock(), _createElementBlock("ul", null, [
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("li", _hoisted_1, [
          _createVNode(_component_base_content_loader)
        ]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_ctx.hasPreviousTasks)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.prevoiusTasks, (task) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: task.startDate,
                  class: "list-item"
                }, [
                  _createVNode(_component_previous_visit, {
                    task: task,
                    class: "visit-item"
                  }, null, 8, ["task"])
                ]))
              }), 128))
            : (_openBlock(), _createElementBlock("li", _hoisted_2, [
                _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.translate('shared.noPreviousVisits')), 1)
              ]))
        ], 64))
  ]))
}